export default async function ({ store, redirect, error, params }) {
  if (store.getters["user/IS_BAND"]) {
    if (store.state.draft.id !== Number(params.id)) {
      try {
        await store.dispatch("draft/SET_CURRENT", Number(params.id))
      } catch (err) {
        return error({ statusCode: 403, message: "Unauthorized" })
      }
    }
    await store.dispatch("tag/FETCH")
  } else return redirect("/")
}
